import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import L1VerticalCard from "../L1VerticalCard/L1VerticalCard";
import L1VerticalCardSkeleton from "../L1VerticalCard/L1VerticalCardSkeleton";
import { dummySummaryRes, l1VerticalCardTypes } from "../data";
import {
	convertValueInCr,
	convertValueInL,
	convertValueInThousands,
	roundDecimalValueUptoTwo,
	roundDecimalValueUptoTwoDigit,
} from "utils/roundDecimalValue";
import { fastapiVmInstance } from "utils/AxiosInstances/RareboxFastApi";

const L1SaleRelatedCards = ({ filter }) => {
	const { setSnackBarOpen, setSnackBar, snackbar } = GlobalState();
	const [resData, setResData] = useState({});
	const [loading, setLoading] = useState(false);

	const fetch = async () => {
		try {
			setLoading(true);
			const body = { filter };

			const res = await fastapiVmInstance.post(`/api/summary-report/sales-aop`, {filter});

			if (res.data.status === "error") throw new Error(res.data?.message);
			const result = res.data.result;
			setResData(result);
			setLoading(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		fetch();
	}, [filter]);

	if (loading)
		return (
			<>
				<L1VerticalCardSkeleton />
				<L1VerticalCardSkeleton />
				<L1VerticalCardSkeleton />
				<L1VerticalCardSkeleton />
				<L1VerticalCardSkeleton />
			</>
		);
	else
		return (
			<>
				<L1VerticalCard
					fullData={resData}
					cardDetails={l1VerticalCardTypes.sale_aop}
					valRoundOffFun={(val) => convertValueInL(val, "string")}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => convertValueInL(val, "number")}
					barGraphlabelData={{ y_axis: "SALES [L]" }}
				/>
				<L1VerticalCard
					hideAop={true}
					fullData={resData}
					cardDetails={l1VerticalCardTypes.qty_aop}
					barGraphlabelData={{ y_axis: "QTY (K)" }}
					valRoundOffFun={(val) => convertValueInThousands(val, "string")}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => convertValueInThousands(val, "number")}
				/>
				<L1VerticalCard
					hideAop={true}
					fullData={resData}
					cardDetails={l1VerticalCardTypes.discount}
					barGraphlabelData={{ y_axis: "DIS %" }}
					valRoundOffFun={(val) => ` ${roundDecimalValueUptoTwo(val)} %`}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => roundDecimalValueUptoTwo(val)}
				/>
				<L1VerticalCard
					hideAop={false}
					fullData={resData}
					cardDetails={l1VerticalCardTypes.gp}
					barGraphlabelData={{ y_axis: "GP (L)" }}
					valRoundOffFun={(val) => convertValueInL(val, "string")}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => convertValueInL(val, "number")}
				/>
				{/* <L1VerticalCard
					hideAop={false}
					fullData={resData}
					cardDetails={l1VerticalCardTypes.gp_contri}
					barGraphlabelData={{ y_axis: "GP %" }}
					valRoundOffFun={(val) => `${roundDecimalValueUptoTwo(val)}%`}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => roundDecimalValueUptoTwo(val)}
				/> */}
				<L1VerticalCard
					hideAop={true}
					fullData={resData}
					cardDetails={l1VerticalCardTypes.ros}
					barGraphlabelData={{ y_axis: "ROS" }}
					valRoundOffFun={(val) => `${roundDecimalValueUptoTwo(val)}`}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => roundDecimalValueUptoTwo(val)}
				/>
				<L1VerticalCard
					hideAop={true}
					fullData={resData}
					cardDetails={{...l1VerticalCardTypes.str, key: "discount"}}
					barGraphlabelData={{ y_axis: "STR" }}
					valRoundOffFun={(val) => `${roundDecimalValueUptoTwo(val)}`}
					percentRoundOffFun={roundDecimalValueUptoTwo}
					barGraphValueConverter={(val) => roundDecimalValueUptoTwo(val)}
				/>
			</>
		);
};

export default L1SaleRelatedCards;
